import { Pipe, PipeTransform } from '@angular/core';
import { StudentFieldLookup } from './student-field.model';

@Pipe({
  name: 'StudentFieldLookupPipe',
  pure: false
})
export class StudentFieldLookupPipe implements PipeTransform {
  transform(fieldOptions: StudentFieldLookup[], filter?) {
    let retObj = [];
    if (fieldOptions != null && fieldOptions != undefined) {
      retObj = fieldOptions.filter(x => x.DataFieldId === filter.DataFieldId);
      retObj.sort((a, b) => {
        if (a.Sequence < b.Sequence) {
          return -1;
        } else if (b.Sequence < a.Sequence) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    return retObj;
  }
}
